import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap'

//i18n
import { withTranslation } from 'react-i18next'
// Redux
import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom'

// users
import user1 from '../../../assets/images/users/person.jpg'
import { useUserInfo } from 'context/userContext'
import './styles.css'

const ProfileMenu = (props) => {
  const [menu, setMenu] = useState(false)
  const { userPlan, setIsRoot, setUserPlan, userName } = useUserInfo()
  const isSidebar = props.variant === 'sidebar'

  function logout() {
    localStorage.removeItem('authUser')
    localStorage.removeItem('userName')
    setIsRoot(false)
    setUserPlan('')
    props.history.push('/login')
  }

  const dropdownMenu = (
    <DropdownMenu className="dropdown-menu-end">
      <div className="dropdown-divider" />
      <Link
        onClick={() => {
          logout()
        }}
        className="dropdown-item"
        to="#"
      >
        <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
        <span>{props.t('Sair')}</span>
      </Link>
    </DropdownMenu>
  )

  if (isSidebar) {
    return (
      <div className="sidebar-profile-wrap">
        <div className="sidebar-profile-card sidebar-profile-btn w-100 d-flex align-items-center">
          <img
            className="rounded-circle sidebar-profile-btn__avatar"
            src={user1}
            alt=""
          />
          <div className="sidebar-profile-btn__meta flex-grow-1 min-w-0">
            <span className="sidebar-profile-btn__name text-truncate d-block">
              {userName || '—'}
            </span>
            <span className="sidebar-profile-btn__plan text-truncate d-block">
              {userPlan || ''}
            </span>
          </div>
        </div>
        <button
          type="button"
          className="btn sidebar-logout-btn w-100 d-flex align-items-center justify-content-center gap-1"
          onClick={logout}
        >
          <i className="bx bx-power-off font-size-16 align-middle text-danger" />
          <span>{props.t('Sair')}</span>
        </button>
      </div>
    )
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
        >
          <span
            style={{
              fontSize: '14px',
              fontWeight: '700',
              marginRight: '2px'
            }}
            className="mobile-hide"
          >
            {userName}
          </span>
          <span
            style={{
              fontSize: '14px',
              fontWeight: '700',
              marginRight: '10px'
            }}
            className="mobile-hide"
          >
            {' '}
            | {userPlan}
          </span>
          <img
            className="rounded-circle header-profile-user"
            src={user1}
            alt="Header Avatar"
          />
        </DropdownToggle>
        {dropdownMenu}
      </Dropdown>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
  variant: PropTypes.oneOf(['sidebar'])
}

const mapStatetoProps = (state) => {
  const { error, success } = state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
